<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Booking Record</h3>
      </div>
    </div>

    <table
      id="myTable"
      class="table table-striped table-bordered"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>Last Name</th>
          <th>Phone</th>
          <th>Date</th>
          <th>Time</th>
          <th>No. of Children</th>
          <th>Vacancy</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </div>
</template>

  <script>
import axios from "axios";
import $ from "jquery";
var table;

export default {
  mounted() {
    this.getBooking();
  },
  methods: {
    detail(id) {
      this.$router.push({
        name: "booking-details",
        params: { id: id },
      });
    },
    getBooking() {
      var $this = this;
      axios
        .get(process.env.VUE_APP_API+"api/staff/Booking")
        .then((response) => {
          var table = $("#myTable").DataTable({
            data: response.data.result,
            columns: [
              { data: "lastname" },
              { data: "phone" },
              { data: "date" },
              {
                data: function (data) {
                  return data.startTime + " - " + data.endTime;
                },
              },
              { data: "noOfChildrens" },
              { data: "vacancy" },
              { data: "bookingStatus" },
              { defaultContent: `<button class="edit" "><i class="material-icons">edit</i></button> <button class="del" "><i class="material-icons">delete</i></button>` },
            ],
          });
          $("#myTable tbody").on("click", ".edit", function () {
            var data = table.row($(this).parents("tr")).data();
            $this.detail(data["bookingId"]);
          });
          $("#myTable tbody").on("click", ".del", async function () {
            var data = table.row($(this).parents("tr")).data();
            await axios
            .delete(
              process.env.VUE_APP_API+"api/staff/Booking/" + data["bookingId"]
            )
          .then((response) => {
            if (response.data.statusCode == 200) {
              alert("Success");
              table.row($(this).parents("tr")).remove().draw();
            }
          })
          //     { defaultContent: "<button>Delete</button>" },
          //   ],
          // });

          // $("#myTable tbody").on("click", "button", async function () {
          //   var data = table.row($(this).parents("tr")).data();

          //   if (confirm(`Remove ${data["bookingId"]}?`)) {
          //     await axios
          //       .delete(
          //         "https://wepark-backend.ive.appliedtech.ltd/api/staff/Booking/" + data["bookingId"]
          //       )
          // .then((response) => {
          // if (response.data.statusCode == 200) {
          //   alert("Success");
          //   table.row($(this).parents("tr")).remove().draw();
          // }
          //       });
          //   }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>